import { render } from "./fileAttachmentUpload.vue?vue&type=template&id=0a6484dd"
import script from "./fileAttachmentUpload.vue?vue&type=script&lang=js"
export * from "./fileAttachmentUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__